<template>
  <div class="inner-row" :style="sprps.gstyle">

    <img
    class="crx-table-row-img"
    src="@/assets/img/illustrations/palette.png" alt="cardboard box" width="80px" height="80px">

    <div class="crx-cell xs4">
      <span class="crx-cell-label">
        Item
      </span>
      <span
      class="font-weight-medium">
        {{ definition.name }}
      </span>
    </div>

    <div class="crx-cell xs4">
      <span class="crx-cell-label">Total in stock</span>
      <span>

        <div
        v-if="totalAvailable > 0"
        class="crx-chip">
          <c-metric-selector
          labelMode
          :inventoryItemID="definition.id" 
          :realValue="totalAvailable">
          </c-metric-selector>
        </div>

        <div
        v-else-if="totalAvailable < 0"
        class="crx-chip pink white--text">
          <c-metric-selector
          labelMode
          :inventoryItemID="definition.id" 
          :realValue="totalAvailable">
          </c-metric-selector>
        </div>

        <div
        v-else
        class="crx-chip pink white--text font-weight-medium">
          Out of stock!
        </div>

      </span>
    </div>

    <div class="crx-cell xs4">
      <span class="crx-cell-label">Quantity required</span>
      <span>
        <div>
          <c-metric-selector
          labelMode
          :inventoryItemID="definition.id" 
          :realValue="required[row.inventory_item_id]">
          </c-metric-selector>
        </div>
        <!-- error message -->
        <div
        v-if="short > 0"
        class="crx-chip pink darken-1 white--text font-weight-normal">
          <v-icon color="pink lighten-3">
            warning
          </v-icon>
          Short
          &nbsp;
          <c-metric-selector
          labelMode
          :inventoryItemID="definition.id" 
          :realValue="Math.abs(short)">
          </c-metric-selector>
        </div>
      </span>
    </div>

    <div class="crx-cell xs4">
      <span class="crx-cell-label">Quantity used</span>
      <span>
        <div>
          <c-metric-selector
          labelMode
          alwaysScale
          :inventoryItemID="definition.id" 
          :realValue="totalDebits">
          </c-metric-selector>
        </div>
        <!-- error message -->
        <div
        v-if="differenceDebitedRequired !== 0"
        class="crx-chip orange darken-1 white--text font-weight-normal">
          <v-icon color="orange lighten-3">
            warning
          </v-icon>
          <span>{{ differenceDebitedRequired > 0 ? 'over ' : 'short '}}</span>
          &nbsp;
          <c-metric-selector
          labelMode
          alwaysScale
          :inventoryItemID="definition.id" 
          :realValue="Math.abs(differenceDebitedRequired)">
          </c-metric-selector>
        </div>
      </span>
    </div>
  </div>
</template>

<script>
import { BigNumber } from 'bignumber.js'

export default {
  props: {
    sprps: null,
    row: null,
    debits: { // [{inventory_id: 666}, ...]
      type: Object,
      default: () => {
        return {}
      }
    },
    debitsFrozen: { // [{inventory_item_id, archive_id, quantity}, ...]
      type: Array,
      default: () => {
        return []
      }
    },
    required: { // {inv_item_id: quantity, inv_item_id: quantity}
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      // 6
    }
  },
  computed: {
    definition () {
      return this.$store.state.db.inventoryDefinitions.definitions[this.row.inventory_item_id]
    },
    inventory () {
      return this.$store.getters['db/inventory/getInventoryOf'](this.row.inventory_item_id)
    },
    totalInventory () {
      return this.inventory.reduce((a, i) => {
        a += i.quantity
        return a
      }, 0)
    },
    totalAvailable () {
      return new BigNumber(this.totalInventory).plus(this.totalReserved).toFixed(6)
    },
    totalDebits () {
      var archiveDict = Object.values(this.debits[this.row.inventory_item_id])
      return Object.values(archiveDict).reduce((a, b) => a + (b || 0), 0)
    },
    totalReserved () {
      var reservedMatches = this.debitsFrozen.filter(item => {
        return item.inventory_item_id === this.row.inventory_item_id
      })
      return reservedMatches.reduce((a, item) => {
        a += item.quantity
        return a
      }, 0)
    },
    short () {
      return this.required[this.row.inventory_item_id] - this.totalAvailable
    },
    differenceDebitedRequired () {
      return this.totalDebits - this.required[this.row.inventory_item_id]
    }
  }
}
</script>
